var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"screening-dialog-result"},[_c('dialog-header',{staticClass:"screening-dialog-result-header",on:{"close":_vm.onDialogClose},model:{value:(_vm.headerTitle),callback:function ($$v) {_vm.headerTitle=$$v},expression:"headerTitle"}}),_vm._m(0)],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"screening-dialog-result-content"},[_c('div',[_vm._v("正在导出数据，请稍后……")])])
}]

export { render, staticRenderFns }